import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {FollowUpModel} from "./follow-up.model";
import {FollowUpService} from './follow-up.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {BasicValidators} from "../shared/basic-validators";


@Component({
  selector: 'app-follow-up-form',
  templateUrl: './follow-up-form.component.html'
})
export class FollowUpFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  followup: FollowUpModel = new FollowUpModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  listOpcoes = [
    {"texto": this.func.traduzir('front.unico'), "valor": "u"},
    {"texto": this.func.traduzir('front.mensal'), "valor": "m"},
    {"texto": this.func.traduzir('front.anual'), "valor": "a"}
  ];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private followUpService: FollowUpService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_followup: [],
      descricao: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      valor: ['', [
        Validators.required
      ]],
      vencimento: ['', [
        Validators.required
      ]],
      opcao: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],

    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_followup'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarFollowUp');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarFollowUp') : this.func.traduzir('front.cadastrarNovoFollowUp');
      }

      if (!id) {
        return;
      }

      this.followUpService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarFollowUp')+': '+json.Payload[0].descricao;
            }else{
              this.title = this.func.traduzir('front.visualizarFollowUp')+': '+json.Payload[0].descricao;
            }
            this.followup = json.Payload[0];
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {

    this.enviando = true;
    let result,
      values = this.followup; //this.form.value;

    if (values.id_followup) {
      result = this.followUpService.editar(values, values.id_followup);
    } else {
      result = this.followUpService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'followup']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/follow-up/follow-up-form.component.ts